import { FieldProps } from '~components/form-fields/props';

import BudgetSections from '../../components/budgets/BudgetSections';

const editBudgetFields: FieldProps = {
  id: {
    type: 'hidden',
  },
  sections: {
    type: 'custom',
    component: BudgetSections,
    dependencies: [
      'id',
      'supplements',
      'sections',
      'price_plan_revision_id',
      'price_plan_deleted',
      'client_id',
      'client_sah_budget_id',
      'package_fixed_id',
      'start_date',
      'end_date',
      'total_amount',
      'available_amount',
      'grand_total',
      'total_includes_case_management',
      'status_id',
      'ignore_sah_filters',
      // Carried through so the nested `budgetDetails` field definitions can read it. Fields.tsx
      // narrows this custom field's value to a pick of ONLY these dependency keys, so the
      // `status_id` control's `disabled`/`deriveWarning` (which read `needs_review`) never see the
      // flag unless it is listed here — it looks unused in this file but is not (TAV-2970).
      'needs_review',
    ],
    colSize: 12,
    order: 500,
  },
};

export default editBudgetFields;
